export default __webpack_public_path__ + "static/media/scholarship_bursaries.86a7b15c.png";